export default __webpack_public_path__ + "static/media/user-edit.d35ffcbb.svg";